import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  openSearch: null,
  closeSearch: null,
}, { prefix: '[SEARCH] ' });
